import CaseStudyPage from "@/pages/portfolio/components/CaseStudyPage";

export default function AiSaasCase() {
  return <CaseStudyPage slug="ai-powered-saas-platform" />;
}